import { childrenShowingClass, getLevelClass } from "./selectorHelpers.js";

/**
 * Determine if the row is a sibling at the given level
 *
 * @param row The row to check
 * @param level The level to check
 * @returns True if the row is a sibling at the given level
 */
export function isSibling(row: HTMLElement, level: number): boolean {
	return row.classList.contains(getLevelClass(level));
}

/**
 * Determine if the row is a direct-descendant of the given level
 *
 * @param row The row to check
 * @param level The level to check
 * @returns True if the row is a direct-descendant of the given level
 */
export function isDescendant(row: HTMLElement, level: number): boolean {
	return row.classList.contains(getLevelClass(level + 1));
}

/**
 * Determine if the given element is an HTML element
 *
 * @param element The element to check
 * @returns True if the element is an HTML element
 */
export function isHTMLElement(element: Node): element is HTMLElement {
	return element.nodeType === 1;
}

/**
 * Determine if the given element is showing.
 *
 * @param element The element to check
 * @returns True if the element is showing
 */
export function isRowShowing(element: HTMLElement): boolean {
	return element.classList.contains(childrenShowingClass);
}
